import { ErrorHandlerInterface } from '../../services/exports/Interfaces';
import { TABLE_UNAVAILABLE_ERROR_CODES, dropUnavailableTable } from '../../hooks/order/tableUnavailable';

interface Args {
  isAtTable: boolean;
  goToMenu: () => void;
  openOrderMethodModal: () => void;
  reloadCompany: () => void;
}

/**
 * The basket's handlers for a 412 from its validation that concerns a table order:
 *
 *  * `orderTimeNotAvailable` (closed, paused, slot gone): the menu with the order-method modal, as
 *    before; at a table the modal has nothing to offer and would turn the order into pickup, so the
 *    restaurant is reloaded instead and the menu and the cart say it is closed or paused.
 *  * `tableUnavailable` (table switched off or deleted, table ordering stopped): the table is dropped
 *    and the menu says why, rather than the default InfoModal leaving the dead table on the cart.
 */
export default function basketTableHandlers({ isAtTable, goToMenu, openOrderMethodModal, reloadCompany }: Args) {
  const orderTimeNotAvailable = (): void => {
    goToMenu();

    if (isAtTable) {
      reloadCompany();

      return;
    }

    openOrderMethodModal();
  };

  const tableUnavailable: ErrorHandlerInterface = Object.fromEntries(
    TABLE_UNAVAILABLE_ERROR_CODES.map((code) => [
      code,
      () => {
        dropUnavailableTable(code);
        goToMenu();
      },
    ]),
  );

  return { orderTimeNotAvailable, tableUnavailable };
}
